<script setup>
const route = useRoute();
const { id } = route.params;
const { data: articleRes } = await useFetch2(`/api/articles/${id}`);

const site = useState("site", () => null);
const article = articleRes.value.detail;

useHead({
  title: article.title,
  meta: [
    {
      name: "title",
      content: [
        article.title,
        "比赛资讯",
        site.value.siteTitle || "mootcourt.cn 模拟法庭",
      ].join(" - "),
    },
    {
      property: "og:title",
      content: article.title,
    },
    {
      property: "og:description",
      content: [
        "比赛资讯",
        site.value.siteTitle || "mootcourt.cn 模拟法庭",
      ].join(" - "),
    },
    ...(article.source
      ? [
          {
            property: "og:url",
            content: article.source,
          },
        ]
      : []),
    {
      property: "description",
      content: article.description,
    },
  ],
});
</script>

<template lang="pug">
WebLayout
  WebSectionTitle 比赛资讯
  .-mt-6.py-6.bg-white
    AppContainer.my-8(v-if="article", slim, style="min-height: 400px")
      h1.text-center.text-2xl.font-bold.my-4 {{ article.title }}
      .text-center.text-hint-400.mb-8
        ASpace
          span {{ formatDateTime(article.publishedAt) }}
          a.link-hint(
            v-if="article.source",
            :href="article.source",
            target="_blank"
          ) 阅读原文
      WebArticleContent(:content="article.content")
</template>

<style lang="scss" scoped>
.link-hint {
  text-decoration: underline;
}
</style>
